import { useNavigate } from "react-router-dom";
import React, { useState } from "react";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Button } from "@mui/material";
import Stack from "@mui/material/Stack";

import Search from "../Search/Search";
import Title from "../../common/Title";
import BatchList from "../../common/BatchList";

import useBatchListState from "../../../hooks/useBatchListState";
import useAuth from "../../../hooks/useAuth";
import { OPERATIONS } from "../../../constants/value";
import { __getActivateBatches } from "../../../api/sim";

/** `showVirtualActivation`: T-Mobile J virtual activation — only for `/client/activate` (set in App.js). */
/** `showCreateSipCustomer`: SIP customer shortcut — only for `/tmobilej/activate` (set in App.js). */
const Activate = ({
  client,
  showCreateSipCustomer = false,
  showVirtualActivation = false,
}) => {
  const { user } = useAuth();
  const nav = useNavigate();

  // search states
  const [searchActive, setSearchActive] = useState(false);

  const {
    data,
    loading,
    metaData,
    response,
    statusCategories,
    handlePageChange,
    handlePageSizeChange,
    handleStatusCategoryChange,
  } = useBatchListState(__getActivateBatches, { client });

  return (
    <>
      <Box sx={{ width: "100%" }}>
        <Title
          variant="h5"
          sx={{ textTransform: "capitalize" }}
          content={`${client ? client : ""} Activations`}
          gutterBottom
        />
        <Search
          key={`${client}-activate`}
          client={client}
          operation={OPERATIONS.activate}
          searchActive={searchActive}
          setSearchActive={setSearchActive}
        />
        {/* if search not active show as desired */}
        {!searchActive &&
          (response ? (
            <>
              <Grid container justifyContent="flex-start" spacing={2}>
                <Grid item>
                  <Stack spacing={2} direction="row" flexWrap="wrap">
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => nav("form")}
                    >
                      {`Activate new SIMs`}
                    </Button>
                    {showCreateSipCustomer ? (
                      <Button
                        variant="outlined"
                        color="primary"
                        onClick={() => nav("sip-customer-form")}
                      >
                        Create SIP customer
                      </Button>
                    ) : null}
                    {showVirtualActivation &&
                    user &&
                    !user.admin &&
                    user.virtual_plan_set === true ? (
                      <Button
                        variant="contained"
                        color="secondary"
                        onClick={() => nav("virtual-form")}
                      >
                        Virtual activation
                      </Button>
                    ) : null}
                  </Stack>
                </Grid>
              </Grid>
              <BatchList
                data={data}
                loading={loading}
                meta={metaData}
                changeNumber={true}
                statusCategories={statusCategories}
                onStatusCategoryChange={handleStatusCategoryChange}
                handlePageChange={handlePageChange}
                handlePageSizeChange={handlePageSizeChange}
              />
            </>
          ) : (
            <Title content="Please wait..." variant="subtitle2" gutterBottom />
          ))}
      </Box>
    </>
  );
};

export default Activate;
